import {
  MORE_CHIP_LABEL_MAX_WIDTH,
  MORE_LABEL_MAX_WIDTH,
  SHOW_MORE_LABEL_MAX_WIDTH,
  TAGS_GAP,
} from './const';

export const DEFAULT_ROWS_COUNT = 1;

const NO_LEFT_MARGIN = 0;

const prepareVisibleItemStyles = (top, left) => ({
  position: 'absolute',
  top,
  left,
  visibility: 'visible',
});

const prepareHiddenItemStyles = () => ({
  position: 'absolute',
  top: 0,
  left: 0,
  visibility: 'hidden',
});

const prepareMoreStyles = (top, left, height, moreLabelMaxWidth) => ({
  position: 'absolute',
  top,
  left,
  maxWidth: moreLabelMaxWidth || MORE_LABEL_MAX_WIDTH,
  height,
});

const getFirstHiddenItemIndex = (itemsStyles) => {
  return itemsStyles.findIndex((itemStyles) => {
    return itemStyles.visibility === 'hidden';
  });
};

export const calculateItemsProps = (
  elementsInfo,
  options,
  moreButtonNewLine,
  setShowMoreButton
) => {
  const rootWidth = options?.rootWidth || 0;
  const rowHeight = options?.rowHeight || 0;
  const maxRows = options?.maxRows || DEFAULT_ROWS_COUNT;
  const tagsGap = options?.tagsGap || TAGS_GAP;
  const horizontalTagsGap = options.horizontalTagsGap || TAGS_GAP;
  const moreLabelWidth = options.showMoreChip
    ? MORE_CHIP_LABEL_MAX_WIDTH
    : options.isExpandable
      ? SHOW_MORE_LABEL_MAX_WIDTH
      : MORE_LABEL_MAX_WIDTH;
  const moreLabelMaxWidth = options?.moreLabelMaxWidth || 0;

  const result = {
    itemsStyles: [],
    firstHiddenItemIndex: 0,
    rowsCount: DEFAULT_ROWS_COUNT,
    moreCount: 0,
    moreStyles: null,
  };

  const calculateTop = () => (rowHeight + tagsGap) * (result.rowsCount - 1);
  let currentLeft = 0;
  if (setShowMoreButton) {
    setShowMoreButton(false);
  }

  elementsInfo.forEach((elementInfo, index) => {
    const currentWidth = elementInfo.width;

    // If item fits in the current row - place it here ...
    if (currentLeft + currentWidth <= rootWidth) {
      result.itemsStyles[index] = prepareVisibleItemStyles(calculateTop(), currentLeft);
      currentLeft = currentLeft + currentWidth + horizontalTagsGap;
    }

    // ... otherwise, check if we still can add rows, and place it as a first item there ...
    else if (result.rowsCount < maxRows || options.isExpanded) {
      result.rowsCount += 1;

      result.itemsStyles[index] = prepareVisibleItemStyles(calculateTop(), 0);
      currentLeft = currentWidth + horizontalTagsGap;
    }

    // ... if we can't add rows, then hide all other elements, but count them for "more" label
    else {
      result.itemsStyles[index] = prepareHiddenItemStyles();
      result.firstHiddenItemIndex = getFirstHiddenItemIndex(result.itemsStyles);
      result.moreCount += 1;
      if (setShowMoreButton) {
        setShowMoreButton(true);
      }

      if (!result.moreStyles) {
        // If "more" label won't fit in what space we have left - hide previous "pain" as well
        if (
          currentLeft > rootWidth - moreLabelWidth - moreLabelMaxWidth &&
          result.itemsStyles[index - 1]
        ) {
          currentLeft = result.itemsStyles[index - 1].left;
          result.itemsStyles[index - 1] = prepareHiddenItemStyles();
          result.moreCount += 1;
        }

        if (moreButtonNewLine) {
          result.rowsCount += 1;
          currentLeft = NO_LEFT_MARGIN;
        }
        result.moreStyles = prepareMoreStyles(
          calculateTop(),
          currentLeft,
          rowHeight,
          moreLabelWidth + moreLabelMaxWidth
        );
        currentLeft = rootWidth;
      }
    }
  });

  if (options.isExpanded) {
    //hide "show less" button if we are back to default rows count
    if (result.rowsCount <= maxRows) {
      result.moreStyles = prepareHiddenItemStyles();
    } else {
      if (setShowMoreButton) {
        setShowMoreButton(true);
      }
      // put "show less" button in a new row if there is no space for it in the current one
      if (
        (currentLeft > rootWidth - moreLabelWidth && result.itemsStyles[elementsInfo.length - 1]) ||
        moreButtonNewLine
      ) {
        result.rowsCount += 1;
        currentLeft = 0;
      }
      result.moreStyles = prepareMoreStyles(calculateTop(), currentLeft, rowHeight);
    }
  }

  return result;
};

export const calculatePanelHeight = (rowsCount, options) => {
  const tagsGap = options?.tagsGap || TAGS_GAP;
  const rowHeight = options?.rowHeight || 0;
  return rowHeight * rowsCount + tagsGap * (rowsCount - 1);
};

export const prepareMoreTagsTooltip = (tags, itemsStyles) => {
  if (!tags) {
    return '';
  }
  const hiddenTags = tags.filter((_, index) => {
    return itemsStyles?.[index]?.visibility === 'hidden';
  });

  return hiddenTags?.map((tag) => `\u2022 ${tag}`).join('\n');
};
